module.exports = __webpack_public_path__ + "img/Weapon_87.dd763c02.png";